module.exports = {
	"shared.crew.original-music-composer": "Komponist",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Udgiver",
	"share-overlay.share": "Del denne video",
	"shared.crew.associate-producer": "Associeret producent",
	"shared.crew.assistant-editor": "Assisterende redaktør",
	"overlay.buy-from": "Køb fra {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Ekstrafotograf",
	"shared.crew.sound-editor": "Lydredigering",
	"shared.crew.print-shipper": "Printshipper",
	"shared.crew.hairstylist": "Hairstylist",
	"shared.crew.makeup-effects": "Makeupeffects",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Produktionsassistent",
	"shared.crew.executive-producer": "Producent",
	"shared.crew.costumer": "Kostume",
	"info-overlay.cast": "Medvirkende",
	"shared.crew.stunt-coordinator": "Stuntregissør",
	"shared.crew.academic-advisor": "Akademisk rådgiver",
	"shared.crew.swing-gang": "Swinggang",
	"shared.crew.best-boy": "Best boy",
	"actions.purchased": "Du ejer denne video",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Dekoratør",
	"shared.crew.adaptation": "Adaptation",
	"shared.crew.school-administrator": "Skoledirektør",
	"shared.crew.cable-person": "Kabelperson",
	"shared.crew.digital-effects": "Digitale effekter",
	"actions.rent": "Leje {price}",
	"info-overlay.created-by": "Af {author}",
	"social-share.twitter": "Se \"{title}\" under {siteUrl}",
	"shared.crew.production-designer": "Produktionsdesigner",
	"info-overlay.crew": "filmhold",
	"shared.crew.producer": "Producent",
	"shared.crew.2nd-unit-dir-of-photography": "2. team af cheffotograf",
	"shared.crew.special-effects": "Special effects",
	"actions.rented": "Lejet indtil {date}",
	"shared.crew.boom-operator": "Boomer",
	"shared.crew.story": "Historie",
	"shared.crew.script-supervisor": "Scripter",
	"shared.crew.director": "Instruktør",
	"shared.crew.choreographer": "Koreograf",
	"shared.crew.production-manager": "Produktionsleder",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Leadperson",
	"shared.crew.location-manager": "Locationmanager",
	"shared.crew.costume-designer": "Kostumedesign",
	"fullscreen.exit": "Afslut fuldskærm",
	"shared.crew.technical-advisor": "Teknisk rådgiver",
	"shared.crew.editor": "Redaktør",
	"shared.crew.additional-grip": "Ekstragrip",
	"actions.buy": "Købspris {price}",
	"shared.crew.assistant-camera": "Assisterende kamera",
	"shared.crew.writer": "Forfatter",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Sammenarbejdende instruktør",
	"fullscreen.enter": "Fuldskærm",
	"shared.crew.animal-trainer": "Dyretræner",
	"shared.crew.assistant-art-director": "Assisterende artdirector",
	"shared.crew.key-grip": "Keygrip",
	"social-button.copy": "Kopier",
	"shared.crew.makeup-artist": "Sminkør",
	"overlay.source-error": "Video kan ikke afspilles",
	"social-button.link": "Link",
	"actions.buy-from": "Køb fra {price}",
	"shared.crew.art-director": "Artdirector",
	"shared.crew.production-coordinator": "Produktionskoordinator",
	"shared.crew.co-director": "Co-instruktør",
	"shared.crew.co-producer": "Co-producent",
	"shared.crew.video-operator": "Videoopreratør",
	"shared.crew.camera-operator": "Kameramand",
	"shared.crew.co-writer": "Co-forfatter",
	"shared.crew.set-designer": "Scenograf ",
	"shared.crew.preview-return": "Previewreturn",
	"shared.crew.property-master": "Propertymaster",
	"shared.crew.cinematographer-dp": "Filmfotograf/DP",
	"shared.crew.grip": "Grip",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Filmtonemester",
	"quality.label": "Kvalitet",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Gaffer",
	"shared.crew.assistant-director": "Assisterende instruktør",
	"actions.subscribe": "Abonner {price}/måned",
	"shared.crew.print-return": "Printreturn",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Dolly",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "2. regiassistent",
	"shared.crew.author-of-adapted-material": "Forfatter af tilpasset materiale"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_da.json
// module id = 2783
// module chunks = 66